import React from 'react';
import { useTranslation } from 'react-i18next';

const SKELETON_ROWS = 6;

export default function CalendarSkeleton(): React.ReactElement {
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-col gap-3 p-4"
      aria-busy="true"
      aria-label={t('agenda/agenda:loading-agenda')}
    >
      <div className="flex items-center justify-between mb-2">
        <div className="skeleton h-8 w-48" />
        <div className="skeleton h-8 w-32" />
      </div>
      {Array.from({ length: SKELETON_ROWS }).map((_, index) => (
        <div key={index} className="flex items-center gap-3">
          <div className="skeleton h-12 w-12 rounded-full" />
          <div className="flex-1 flex flex-col gap-2">
            <div className="skeleton h-4 w-3/4" />
            <div className="skeleton h-3 w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
}
